import React from 'react';
import { Empty } from 'antd'; // Import Empty
import './styles/KeyMetrics.css';

const KeyMetrics = ({ periodData }) => {
  // Check if periodData is effectively empty or in its initial placeholder state
  if (
    !periodData ||
    (periodData.averageRating === 'N/A' &&
      periodData.totalReviews === 'N/A' && // Or 0 if that's how it's set for no data
      periodData.positiveReviews === 'N/A' &&
      periodData.negativeReviews === 'N/A' &&
      periodData.busiestDay === 'N/A' &&
      periodData.peakReviews === 'N/A') ||
    (periodData.averageRating === '...' &&
      periodData.totalReviews === '...' &&
      periodData.positiveReviews === '...' &&
      periodData.negativeReviews === '...' &&
      periodData.busiestDay === '...' &&
      periodData.peakReviews === '...')
  ) {
    return (
      <div className="key-metrics">
        <h2>Key Metrics for Selected Period</h2>
        <div className="metrics-grid" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Empty description="Key metrics will appear here once there is enough data for the selected period." />
        </div>
      </div>
    );
  }

  // Provide default values or loading indicators if periodData is not fully populated yet
  const avgRating = periodData.averageRating !== '...' && periodData.averageRating !== 'N/A' 
                    ? `${periodData.averageRating}★` 
                    : (periodData.averageRating || '...'); // Show '...' or 'N/A'
  const totalReviews = periodData.totalReviews !== '...' && periodData.totalReviews !== 'N/A' 
                       ? periodData.totalReviews 
                       : (periodData.totalReviews || '...');
  // Use the calculated positive/negative reviews from periodData
  const positiveReviews = periodData.positiveReviews !== '...' && periodData.positiveReviews !== 'N/A'
                          ? periodData.positiveReviews
                          : (periodData.positiveReviews || '...');
  const negativeReviews = periodData.negativeReviews !== '...' && periodData.negativeReviews !== 'N/A'
                          ? periodData.negativeReviews
                          : (periodData.negativeReviews || '...');
  const busiestDay = periodData.busiestDay || '...';
  const peakReviews = periodData.peakReviews !== '...' && periodData.peakReviews !== 'N/A' 
                      ? periodData.peakReviews 
                      : (periodData.peakReviews || '...');


  return (
    <div className="key-metrics">
      <h2>Key Metrics for Selected Period</h2>
      <div className="metrics-grid">
        <div className="metric-card">
          <div className="metric-name">Average Rating</div>
          {/* Display calculated or placeholder value */}
          <div className="metric-value">{avgRating}</div>
        </div>
        
        <div className="metric-card">
          <div className="metric-name">Total Reviews</div>
          <div className="metric-value">{totalReviews}</div>
        </div>
        
        <div className="metric-card">
          <div className="metric-name">Positive Reviews (4-5★)</div>
          {/* Display calculated positive reviews */}
          <div className="metric-value">{positiveReviews}</div>
        </div>
        
        <div className="metric-card">
          <div className="metric-name">Negative Reviews (1-3★)</div>
          {/* Display calculated negative reviews */}
          <div className="metric-value">{negativeReviews}</div>
        </div>
        
        <div className="metric-card">
          <div className="metric-name">Busiest Day</div>
          <div className="metric-value">{busiestDay}</div>
        </div>
        
        <div className="metric-card">
          <div className="metric-name">Peak Reviews</div>
          <div className="metric-value">{peakReviews}</div>
        </div>
      </div>
    </div>
  );
};

export default KeyMetrics;